<template>
  <ui-toast></ui-toast>
  <ui-toolbar>
    <template #start>
      <ui-button v-if="canMenuBeVisible" class="p-button-text" icon="pi pi-ellipsis-v"
                 @click="menuVisible=!menuVisible"></ui-button>
      <div>
        <svg height="35" viewBox="0 0 390 120" width="120">
          <g fill="#005792">
            <path
                d="M31.488 90.764c-2.846-2.002-6.808-1.75-9.353.796a7.31 7.31 0 0 0 0 10.325 7.28 7.28 0 0 0 5.163 2.137 7.28 7.28 0 0 0 5.163-2.135c2.545-2.544 2.798-6.507.795-9.354l8.009-8.009 6.222 6.222-3.68 3.679a1.25 1.25 0 1 0 1.768 1.767l3.68-3.679 6.221 6.222-8.01 8.01c-2.847-2.004-6.809-1.75-9.353.793a7.31 7.31 0 0 0 0 10.327A7.28 7.28 0 0 0 43.278 120a7.284 7.284 0 0 0 5.162-2.135c2.544-2.544 2.798-6.505.794-9.353l8.01-8.01 7.363 7.365-3.678 3.678a1.25 1.25 0 1 0 1.767 1.767l3.68-3.677 2.74 2.74a1.246 1.246 0 0 0 1.767 0l11.872-11.872 8.01 8.009c-2.004 2.848-1.75 6.81.794 9.353A7.28 7.28 0 0 0 96.72 120a7.28 7.28 0 0 0 5.163-2.135 7.31 7.31 0 0 0 0-10.326c-2.542-2.543-6.505-2.8-9.352-.795l-8.009-8.009 14.211-14.211 8.01 8.01c-2.004 2.846-1.75 6.809.793 9.353a7.28 7.28 0 0 0 5.164 2.135 7.284 7.284 0 0 0 5.163-2.135 7.31 7.31 0 0 0 0-10.326c-2.545-2.547-6.507-2.8-9.353-.797l-8.01-8.008 11.873-11.872a1.25 1.25 0 0 0 0-1.767l-2.74-2.74 3.677-3.68a1.25 1.25 0 1 0-1.767-1.767l-3.678 3.679-7.363-7.364 8.008-8.01a7.284 7.284 0 0 0 4.19 1.342 7.284 7.284 0 0 0 5.163-2.136 7.31 7.31 0 0 0 0-10.325 7.308 7.308 0 0 0-10.326 0c-2.545 2.542-2.798 6.505-.795 9.352l-8.009 8.009-6.222-6.222 3.68-3.679a1.25 1.25 0 1 0-1.768-1.767l-3.68 3.679-6.221-6.222 8.01-8.01a7.283 7.283 0 0 0 4.188 1.342 7.28 7.28 0 0 0 5.163-2.135c2.848-2.848 2.848-7.48 0-10.327s-7.479-2.848-10.325 0c-2.544 2.544-2.798 6.505-.794 9.353l-8.01 8.01-7.363-7.365 3.678-3.678a1.25 1.25 0 1 0-1.767-1.767l-3.68 3.677-2.74-2.74a1.25 1.25 0 0 0-1.767 0L57.244 39.498l-8.01-8.009c2.004-2.848 1.75-6.81-.794-9.353a7.31 7.31 0 0 0-10.325 0 7.31 7.31 0 0 0 0 10.326 7.28 7.28 0 0 0 5.163 2.136 7.283 7.283 0 0 0 4.189-1.341l8.009 8.009-14.211 14.211-8.01-8.01c2.004-2.846 1.75-6.809-.793-9.353a7.308 7.308 0 0 0-10.327 0 7.31 7.31 0 0 0 0 10.326 7.28 7.28 0 0 0 5.163 2.137 7.284 7.284 0 0 0 4.19-1.342l8.01 8.01-11.873 11.872a1.25 1.25 0 0 0 0 1.767l2.74 2.74-3.677 3.68a1.25 1.25 0 1 0 1.767 1.767l3.678-3.679 7.363 7.364-8.008 8.008zm-.794 9.355a4.807 4.807 0 0 1-6.792 0 4.807 4.807 0 0 1 0-6.792 4.785 4.785 0 0 1 3.396-1.404c1.23 0 2.46.468 3.396 1.404a4.807 4.807 0 0 1 0 6.792zm15.979 15.979c-1.873 1.872-4.92 1.872-6.792 0s-1.873-4.92 0-6.792a4.787 4.787 0 0 1 3.397-1.404c1.228 0 2.459.468 3.395 1.404a4.807 4.807 0 0 1 0 6.792zm53.445-6.792a4.807 4.807 0 0 1 0 6.792 4.807 4.807 0 0 1-6.792 0 4.807 4.807 0 0 1 0-6.792 4.785 4.785 0 0 1 3.395-1.404c1.23 0 2.46.468 3.397 1.404zM112.7 91.923c1.23 0 2.46.468 3.396 1.404a4.807 4.807 0 0 1 0 6.792 4.807 4.807 0 0 1-6.792 0 4.807 4.807 0 0 1 0-6.792 4.787 4.787 0 0 1 3.396-1.404zm-3.396-52.04a4.787 4.787 0 0 1 3.396-1.405c1.23 0 2.46.468 3.396 1.404a4.807 4.807 0 0 1 0 6.792 4.807 4.807 0 0 1-6.792 0 4.807 4.807 0 0 1 0-6.792zm-15.979-15.98a4.785 4.785 0 0 1 3.395-1.403c1.23 0 2.46.467 3.397 1.403a4.807 4.807 0 0 1 0 6.792 4.807 4.807 0 0 1-6.792 0 4.807 4.807 0 0 1 0-6.792zm-53.445 6.792a4.807 4.807 0 0 1 0-6.792 4.787 4.787 0 0 1 3.397-1.403c1.228 0 2.459.467 3.395 1.403a4.807 4.807 0 0 1 0 6.792 4.807 4.807 0 0 1-6.792 0zM23.902 46.674a4.807 4.807 0 0 1 0-6.792 4.785 4.785 0 0 1 3.396-1.404c1.23 0 2.46.468 3.396 1.404a4.807 4.807 0 0 1 0 6.792 4.807 4.807 0 0 1-6.792 0zM70 30.278l19.86 19.857c0 .002 0 .003.002.004l.004.003L109.722 70 70 109.723 50.14 89.866c0-.002 0-.003-.002-.004l-.004-.003L30.277 70l39.722-39.722z"
                xmlns="http://www.w3.org/2000/svg"/>
            <path
                d="M53.577 81.211a1.225 1.225 0 0 0 .315.04h30.509c5.694 0 10.328-4.62 10.328-10.3S90.095 60.65 84.4 60.65c-.158 0-.317.004-.48.012a8.357 8.357 0 0 0-7.679-5.089 8.253 8.253 0 0 0-3.755.895 10.36 10.36 0 0 0-9.078-5.408c-5.695 0-10.33 4.62-10.33 10.301 0 .45.03.899.09 1.348-4.6.57-8.171 4.495-8.171 9.235 0 4.858 3.749 8.882 8.58 9.267zm.75-16.075.309.02a1.253 1.253 0 0 0 1.262-1.601 7.782 7.782 0 0 1-.32-2.194c0-4.3 3.513-7.8 7.83-7.8a7.843 7.843 0 0 1 7.353 5.15 1.253 1.253 0 0 0 1.935.567 5.792 5.792 0 0 1 3.545-1.205 5.841 5.841 0 0 1 5.62 4.268 1.244 1.244 0 0 0 1.386.904 7.922 7.922 0 0 1 1.152-.095c4.317 0 7.828 3.5 7.828 7.8s-3.512 7.801-7.826 7.801H54.123a1.525 1.525 0 0 0-.167-.021c-3.623-.194-6.46-3.175-6.46-6.786 0-3.754 3.063-6.808 6.831-6.808z"
                xmlns="http://www.w3.org/2000/svg"/>
          </g>
          <path
              d="m177.38 91.795-4.442-10.178h-23.07l-4.44 10.178H140l19.245-43.178h4.256l19.307 43.178h-5.429zM151.78 77.299h19.245l-9.622-21.959zm62.176-28.682h5.12v27.51c0 10.61-6.908 16.593-15.667 16.593s-15.668-5.983-15.668-16.593v-27.51h5.12v27.51c0 8.08 4.811 11.72 10.548 11.72s10.547-3.64 10.547-11.72v-27.51zm40.403 0v4.811h-11.967v38.367h-5.12V53.428h-12.028v-4.811h29.115zM281.685 48c11.226 0 22.082 9.13 22.082 22.206s-10.856 22.206-22.082 22.206c-11.288 0-22.082-9.13-22.082-22.206S270.397 48 281.685 48zm0 39.539c8.45 0 16.778-7.156 16.778-17.333s-8.327-17.333-16.778-17.333c-8.512 0-16.778 7.155-16.778 17.333s8.266 17.333 16.778 17.333zm73.526-38.922v43.178h-5.243V60.09l-15.174 31.705H330.6l-15.113-31.643v31.643h-5.243V48.617h5.058l17.456 36.146 17.395-36.146h5.058zm27.14 18.936c4.38 1.974 7.649 6.107 7.649 11.473 0 8.266-7.032 13.386-14.495 13.386-7.402 0-14.434-5.12-14.434-13.386 0-5.366 3.269-9.499 7.648-11.473-3.084-1.912-5.058-5.058-5.058-8.697 0-5.86 4.565-10.856 11.844-10.856 7.34 0 11.904 4.996 11.904 10.856 0 3.64-1.973 6.785-5.058 8.697zm-13.817-8.45c0 3.578 2.9 6.662 6.97 6.662 4.133 0 7.032-3.084 7.032-6.662 0-3.516-2.652-6.6-7.031-6.6-4.318 0-6.97 3.084-6.97 6.6zm6.97 28.682c4.997 0 9.191-3.392 9.191-8.759 0-5.304-4.132-8.82-9.19-8.82-4.997 0-9.13 3.516-9.13 8.82 0 5.367 4.133 8.76 9.13 8.76z"
              fill="#005792"/>
        </svg>
      </div>
    </template>
  </ui-toolbar>

  <div class="wrapper">
    <div class="flex">
      <div v-if="menuVisible" class="nav-bar">
        <div class="inner">
          <ui-menu :model="menuItems" class="blue-icon">
            <template #start>
              <button
                  class="w-full p-link flex align-items-center p-2 pl-3 text-color hover:surface-200 border-noround">
                <ui-avatar :image="'https://www.gravatar.com/avatar/' + hash + '?size=30'" class="mr-2"/>
                <div class="flex flex-column align">
                  <span class="font-bold">{{ currentUser.name }}</span>
                  <span class="text-sm">{{ currentUser.role }}</span>
                </div>
              </button>
            </template>
            <template #end>
              <button class="w-full p-link flex align-items-center p-2 pl-3 text-color hover:surface-200 border-noround"
                      @click="logout">
                <i class="pi pi-sign-out"/>
                <span class="ml-2">Log Out</span>
              </button>
            </template>
          </ui-menu>
        </div>
      </div>
      <div class="content-panel">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, watch} from 'vue';
import {useAuthStore} from './store/authStore';
import {useRoute, useRouter} from 'vue-router';
import md5 from "md5";

const router = useRouter();
const route = useRoute();
const menuVisible = ref(true);
const canMenuBeVisible = ref(true);
const hash = ref("");
const menuItems = ref([
  {separator: true},
  {
    label: "Projects",
    icon: 'pi pi-folder',
    command: () => {
      router.push("/");
    }
  },
  {
    label: "Jobs",
    icon: 'pi pi-list',
    command: () => {
      router.push("/jobs");
    }
  },
  {
    label: "Runners",
    icon: 'pi pi-play',
    command: () => {
      router.push("/runners");
    }
  },
  {
    label: "Schedules",
    icon: 'pi pi-clock',
    command: () => {
      router.push("/view-schedules");
    }
  },
  {
    label: "Users",
    icon: 'pi pi-user',
    command: () => {
      router.push("/users");
    }
  },
  {separator: true}
]);
const currentUser = ref({name: "", email: "", role: "", userId: ""});
const store = useAuthStore();

function checkRoute() {
  if (route.name == "login" || route.name == undefined) {
    menuVisible.value = false;
    canMenuBeVisible.value = false;
  }

  if (!store.isAuthorised && route.name != "login") {
    router.push("/login");
  } else {
    currentUser.value.email = store.user.email;
    currentUser.value.name = store.user.name;
    currentUser.value.role = store.user.role;
    currentUser.value.userId = store.user.id;
    hash.value = md5(store.user.email.trim().toLowerCase())
    if (route.name != "login") {
      menuVisible.value = true;
      canMenuBeVisible.value = true;
    }
  }
}

checkRoute();

watch(
    () => route.name,
    async push => {
      checkRoute();
    }
)

function logout() {
  store.logout();
  router.push("/login")
}

</script>


<style lang="scss">

html, #app {
  height: 100%
}

body {
  margin: 0;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: var(--surface-ground);
  font-family: var(--font-family);
  font-weight: 400;
  color: var(--text-color);
  -webkit-font-smoothing: antialiased;
}

.wrapper {
  /* padding: 5px 20px;*/
  height: 100%;
}

.tools {
  font-size: 40px;
  padding: 5px 20px;
}

.p-toolbar .pi {
  font-size: 1em;
}

.p-toolbar {
  padding: 0.8rem;
  font-size: 1.5em !important;
}

.p-toolbar a:link,
.p-toolbar a:visited {
  color: var(--text-color);
  text-decoration: none;
}

.avatar {
  width: 30px;
  height: 30px;
  margin-bottom: -3px;
}


.flex {
  display: flex;
  height: 100%
}

.nav-bar {
  max-width: 290px;
  height: 100%;
  /*background: $primary;*/
  flex-grow: 2;

  .inner {
    padding: 10px;

    .p-menu {
      width: 100%
    }

  }
}

.content-panel {
  flex-grow: 10;
  padding: 10px 10px 10px 10px;

}

.blue-icon .pi {
  color: #2196f3 !important;
}
</style>
